var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"White"},attrs:{"footer":""}},[_c('v-app-bar',{attrs:{"flat":"","app":"","dense":""}},[_vm._v(_vm._s(_vm.title))]),_c('v-content',[_c('router-view',{key:_vm.$route.fullPath,ref:"view-router",attrs:{"id":"view-router","scrollable":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }